(() => {
  let timer;
  function updateTheme() {
    const now = new Date();
    const hour = now.getHours();
    const dim = hour >= 22 || hour < 6;
    document.documentElement.dataset.appearance = dim ? 'dim' : 'day';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = dim ? '#49443e' : '#b8b0a4';
    clearTimeout(timer);
    // Local device time, refreshed while the page remains open.
    timer = setTimeout(updateTheme, 60000 - now.getSeconds() * 1000 - now.getMilliseconds());
  }
  document.addEventListener('visibilitychange', updateTheme);
  addEventListener('pageshow', updateTheme);
  updateTheme();
})();